module.exports = __webpack_public_path__ + "img/08.5dcc4e1c.svg";